import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { useI18n } from "@/i18n/I18nContext";
import { Seo } from "@/components/Seo";
import { BLOG_POSTS } from "@/data/blogPosts";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const { tl, lang } = useI18n();
  return (
    <PublicLayout>
      <Seo
        title="Blog fitness & Pilates en Coronado, Panamá — Frenchies"
        description="Consejos de entrenamiento, Pilates, y vida activa en Coronado y Panamá Oeste, por los coaches de Frenchies Fitness & Pilates."
        path="/blog"
        keywords="blog fitness Coronado, consejos entrenamiento Panamá, Pilates Coronado, vida sana Coronado"
      />
      <section className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">{tl({ es: "Blog", en: "Blog", fr: "Blog" })}</h1>
        <p className="mt-3 max-w-2xl text-muted-foreground">
          {tl({ es: "Entrenamiento, Pilates y vida activa en Coronado, escrito por nuestros coaches.", en: "Training, Pilates and active living in Coronado, written by our coaches.", fr: "Entraînement, Pilates et vie active à Coronado, écrit par nos coachs." })}
        </p>
        <div className="mt-10 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {BLOG_POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
              className="group overflow-hidden rounded-3xl border border-border bg-card transition-transform duration-300 hover:-translate-y-1">
              <img src={p.image} alt={p.title[lang] || p.title.es} loading="lazy" className="h-48 w-full object-cover" />
              <div className="p-6">
                <time dateTime={p.date} className="text-xs uppercase tracking-wider text-muted-foreground">{new Date(p.date).toLocaleDateString(lang === "en" ? "en-US" : lang === "fr" ? "fr-FR" : "es-PA", { year: "numeric", month: "long", day: "numeric" })}</time>
                <h2 className="mt-2 font-display text-lg font-semibold leading-snug group-hover:text-primary">{tl(p.title)}</h2>
                <p className="mt-2 text-sm text-muted-foreground">{tl(p.excerpt)}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">{tl({ es: "Leer", en: "Read", fr: "Lire" })} <ArrowRight className="h-4 w-4" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
